import React from "react";
const CallToAction = () => {
  return (
    <div className="w-full flex items-center justify-center text-white cta">
      <div className="mx-8 w-full h-96 text-center lg:text-left py-16 px-12 flex lg:justify-between items-center">
        <div className="w-full flex flex-col lg:flex-row lg:justify-around">
          <div className="mb-4">
            <p className="text-2xl md:text-4xl font-bold mb-4">
              Ready to Navigate the Blockchain Revolution?
            </p>
            <p className="text-lg md:text-2xl">
              Let us be your guide in the fast-paced world of blockchain and
              crypto. Whether you need expert trading strategies, market
              insights, or access to exclusive investment opportunities, we’re
              here to help you achieve your goals.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
